import main from '../main.js'
import * as types from './types'
import constant from '@/constants'

export default {
  [types.SET_LANG]({commit}, payload) {
    commit(types.SET_LANG, payload)
  },
  setOrderTime({commit, state}, payload) {
    commit(types.SET_ORDER_TIME, payload)
  },
  [types.SET_PAYMENT_STATUS]({commit, state}, payload) {
    commit(types.SET_PAYMENT_STATUS, payload)
  },
  [types.SET_IS_VALID_ORDER_TIME]({commit, state}, payload) {
    commit(types.SET_IS_VALID_ORDER_TIME, payload)
  },
  [types.SET_CATEGORY_LIST]({commit, state}, payload) {
    commit(types.SET_CATEGORY_LIST, payload)
  },
  [types.SET_SELECTED_PRODUCT]({commit, state}, payload) {
    commit(types.SET_SELECTED_PRODUCT, payload)
  },
  [types.SET_SELECTED_CATEGORY]({commit, state}, payload) {
    commit(types.SET_SELECTED_CATEGORY, payload)
  },
  [types.SET_ATTRIBUTES_LIST]({commit, state}, payload) {
    commit(types.SET_ATTRIBUTES_LIST, payload)
  },
  [types.SET_ATTRIBUTES_FILTER]({commit, state}, payload) {
    commit(types.SET_ATTRIBUTES_FILTER, payload)
  },
  [types.SET_SELECTED_SUB_CATEGORY]({commit, state}, payload) {
    commit(types.SET_SELECTED_SUB_CATEGORY, payload)
  },
  [types.SET_SELECTED_CART]({commit, state}, payload) {
    commit(types.SET_SELECTED_CART, payload)
  },
  [types.SET_DISPOSITION]({commit, state}, payload) {
    commit(types.SET_DISPOSITION, payload)
  },
  [types.SET_USER]({commit, state}, payload) {
    commit(types.SET_USER, payload)
  },
  [types.SET_SELECTED_OUTLET]({commit, state}, payload) {
    if(payload && payload.outletId && payload.orderType){
      main.setOutletById(payload.outletId, payload.orderType)

      commit(types.SET_SELECTED_OUTLET, payload)
    }
  },
  [types.SET_HUT_OUTLET_ID]({commit, state}, payload) {
    commit(types.SET_HUT_OUTLET_ID, payload)
  },
  [types.SET_SELECTED_HUT_OUTLET]({commit, state}, payload) {
    commit(types.SET_SELECTED_HUT_OUTLET, payload)
  },
  [types.SET_SIDEBAR_OPEN]({commit, state}, payload) {
    commit(types.SET_SIDEBAR_OPEN, payload)
  },
  [types.SET_HOME_SIDEBAR_OPEN] ({commit, state}, payload) {
    commit(types.SET_HOME_SIDEBAR_OPEN, payload)
  },
  [types.SET_TRIGGER_CHOOSING_TOPPING]({commit, state}, payload) {
    commit(types.SET_TRIGGER_CHOOSING_TOPPING, payload)
  },
  [types.SET_SELECTED_SIZE]({commit, state}, payload) {
    commit(types.SET_SELECTED_SIZE, payload)
  },
  [types.SET_SELECTED_CRUST]({commit, state}, payload) {
    commit(types.SET_SELECTED_CRUST, payload)
  },
  [types.REMOVE_SELECTED_SIZE_N_CRUST]({commit, state}, payload) {
    commit(types.REMOVE_SELECTED_SIZE_N_CRUST, payload)
  },
  [types.SET_EXTRA_TOPPINGS]({commit, state}, payload) {
    commit(types.SET_EXTRA_TOPPINGS, payload)
  },
  [types.SET_DEFAULT_TOPPINGS]({commit, state}, payload) {
    commit(types.SET_DEFAULT_TOPPINGS, payload)
  },
  [types.UPDATE_QUANTITY_EXTRA_TOPPINGS]({commit, state}, payload) {
    commit(types.UPDATE_QUANTITY_EXTRA_TOPPINGS, payload)
  },
  [types.ADD_SELECTED_EXTRA_TOPPING]({commit, state}, payload) {
    commit(types.ADD_SELECTED_EXTRA_TOPPING, payload)
    commit(types.UPDATE_QUANTITY_EXTRA_TOPPINGS, {uuid: payload.uuid, action: constant.TOPPING.EXTRA.ADD})
  },
  [types.REMOVE_SELECTED_EXTRA_TOPPING]({commit, state}, payload) {
    commit(types.REMOVE_SELECTED_EXTRA_TOPPING, payload)
    commit(types.UPDATE_QUANTITY_EXTRA_TOPPINGS, {uuid: payload.uuid, action: constant.TOPPING.EXTRA.REMOVE})
  },
  [types.RESET_ADDED_EXTRA_TOPPINGS]({commit, state}, payload) {
    commit(types.RESET_ADDED_EXTRA_TOPPINGS, payload)
  },
  [types.UPDATE_QUANTITY_DEFAULT_TOPPINGS]({commit, state}, payload) {
    commit(types.UPDATE_QUANTITY_DEFAULT_TOPPINGS, payload)
  },
  [types.REMOVE_SELECTED_DEFAULT_TOPPING]({commit, state}, payload) {
    commit(types.REMOVE_SELECTED_DEFAULT_TOPPING, payload)
    commit(types.UPDATE_QUANTITY_DEFAULT_TOPPINGS, {uuid: payload.uuid, action: constant.TOPPING.DEFAULT.REMOVE})
  },
  [types.RE_ADD_SELECTED_DEFAULT_TOPPING]({commit, state}, payload) {
    commit(types.RE_ADD_SELECTED_DEFAULT_TOPPING, payload)
    commit(types.UPDATE_QUANTITY_DEFAULT_TOPPINGS, {uuid: payload.uuid, action: constant.TOPPING.DEFAULT.READD})
  },
  [types.RESET_REMOVED_DEFAULT_TOPPINGS]({commit, state}, payload) {
    commit(types.RESET_REMOVED_DEFAULT_TOPPINGS, payload)
  },
  [types.RESET_QUANTITY_TOPPINGS]({commit, state}, payload) {
    commit(types.RESET_QUANTITY_TOPPINGS, payload)
  },

  /**
   * HH
   * */
  [types.SET_SELECTED_HH_SIZE]({commit, state}, payload) {
    commit(types.SET_SELECTED_HH_SIZE, payload)
  },
  [types.SET_SELECTED_HH_CRUST]({commit, state}, payload) {
    commit(types.SET_SELECTED_HH_CRUST, payload)
  },
  [types.REMOVE_SELECTED_HH_SIZE_N_CRUST]({commit, state}, payload) {
    commit(types.REMOVE_SELECTED_HH_SIZE_N_CRUST, payload)
  },
  [types.SET_HH_SIZES]({commit, state}, payload) {
    commit(types.SET_HH_SIZES, payload)
  },
  [types.SET_HH_CRUSTES]({commit, state}, payload) {
    commit(types.SET_HH_CRUSTES, payload)
  },
  [types.SET_HH_PIZZA_LIST]({commit, state}, payload) {
    commit(types.SET_HH_PIZZA_LIST, payload)
  },

  // LEFT pizza
  [types.SET_LEFT_PIZZA]({commit, state}, payload) {
    commit(types.SET_LEFT_PIZZA, payload)
  },
    // *** [LEFT] TOPPINGS
  [types.SET_LEFT_EXTRA_TOPPINGS]({commit, state}, payload) {
    commit(types.SET_LEFT_EXTRA_TOPPINGS, payload)
  },
  [types.SET_LEFT_DEFAULT_TOPPINGS]({commit, state}, payload) {
    commit(types.SET_LEFT_DEFAULT_TOPPINGS, payload)
  },
  [types.REMOVE_LEFT_SELECTED_EXTRA_TOPPING]({commit, state}, payload) {
    commit(types.REMOVE_LEFT_SELECTED_EXTRA_TOPPING, payload)
    commit(types.UPDATE_QUANTITY_LEFT_EXTRA_TOPPINGS, {uuid: payload.uuid, action: constant.TOPPING.EXTRA.REMOVE})
  },
  [types.UPDATE_QUANTITY_LEFT_EXTRA_TOPPINGS]({commit, state}, payload) {
    commit(types.UPDATE_QUANTITY_LEFT_EXTRA_TOPPINGS, payload)
  },
  [types.UPDATE_QUANTITY_LEFT_DEFAULT_TOPPINGS]({commit, state}, payload) {
    commit(types.UPDATE_QUANTITY_LEFT_DEFAULT_TOPPINGS, payload)
  },
  [types.RESET_QUANTITY_LEFT_TOPPINGS]({commit, state}, payload) {
    commit(types.RESET_QUANTITY_LEFT_TOPPINGS, payload)
  },
  [types.ADD_LEFT_SELECTED_EXTRA_TOPPING]({commit, state}, payload) {
    commit(types.ADD_LEFT_SELECTED_EXTRA_TOPPING, payload)
    commit(types.UPDATE_QUANTITY_LEFT_EXTRA_TOPPINGS, {uuid: payload.uuid, action: constant.TOPPING.EXTRA.ADD})
  },
  [types.RESET_LEFT_ADDED_EXTRA_TOPPINGS]({commit, state}, payload) {
    commit(types.RESET_LEFT_ADDED_EXTRA_TOPPINGS, payload)
  },
  [types.REMOVE_LEFT_SELECTED_DEFAULT_TOPPING]({commit, state}, payload) {
    commit(types.REMOVE_LEFT_SELECTED_DEFAULT_TOPPING, payload)
    commit(types.UPDATE_QUANTITY_LEFT_DEFAULT_TOPPINGS, {uuid: payload.uuid, action: constant.TOPPING.DEFAULT.REMOVE})
  },
  [types.RE_ADD_LEFT_SELECTED_DEFAULT_TOPPING]({commit, state}, payload) {
    commit(types.RE_ADD_LEFT_SELECTED_DEFAULT_TOPPING, payload)
    commit(types.UPDATE_QUANTITY_LEFT_DEFAULT_TOPPINGS, {uuid: payload.uuid, action: constant.TOPPING.DEFAULT.READD})
  },
  [types.RESET_LEFT_REMOVED_DEFAULT_TOPPINGS]({commit, state}, payload) {
    commit(types.RESET_LEFT_REMOVED_DEFAULT_TOPPINGS, payload)
  },
  [types.RESET_LEFT_TOPPINGS]({commit, state}, payload) {
    commit(types.RESET_LEFT_TOPPINGS, payload)
  },


  // RIGHT pizza
  [types.SET_RIGHT_PIZZA]({commit, state}, payload) {
    commit(types.SET_RIGHT_PIZZA, payload)
  },
    // *** [RIGHT] TOPPINGS
  [types.SET_RIGHT_EXTRA_TOPPINGS]({commit, state}, payload) {
    commit(types.SET_RIGHT_EXTRA_TOPPINGS, payload)
  },
  [types.SET_RIGHT_DEFAULT_TOPPINGS]({commit, state}, payload) {
    commit(types.SET_RIGHT_DEFAULT_TOPPINGS, payload)
  },
  [types.REMOVE_RIGHT_SELECTED_EXTRA_TOPPING]({commit, state}, payload) {
    commit(types.REMOVE_RIGHT_SELECTED_EXTRA_TOPPING, payload)
    commit(types.UPDATE_QUANTITY_RIGHT_EXTRA_TOPPINGS, {uuid: payload.uuid, action: constant.TOPPING.EXTRA.REMOVE})
  },
  [types.UPDATE_QUANTITY_RIGHT_EXTRA_TOPPINGS]({commit, state}, payload) {
    commit(types.UPDATE_QUANTITY_RIGHT_EXTRA_TOPPINGS, payload)
  },
  [types.UPDATE_QUANTITY_RIGHT_DEFAULT_TOPPINGS]({commit, state}, payload) {
    commit(types.UPDATE_QUANTITY_RIGHT_DEFAULT_TOPPINGS, payload)
  },
  [types.RESET_QUANTITY_RIGHT_TOPPINGS]({commit, state}, payload) {
    commit(types.RESET_QUANTITY_RIGHT_TOPPINGS, payload)
  },
  [types.ADD_RIGHT_SELECTED_EXTRA_TOPPING]({commit, state}, payload) {
    commit(types.ADD_RIGHT_SELECTED_EXTRA_TOPPING, payload)
    commit(types.UPDATE_QUANTITY_RIGHT_EXTRA_TOPPINGS, {uuid: payload.uuid, action: constant.TOPPING.EXTRA.ADD})
  },
  [types.RESET_RIGHT_ADDED_EXTRA_TOPPINGS]({commit, state}, payload) {
    commit(types.RESET_RIGHT_ADDED_EXTRA_TOPPINGS, payload)
  },
  [types.REMOVE_RIGHT_SELECTED_DEFAULT_TOPPING]({commit, state}, payload) {
    commit(types.REMOVE_RIGHT_SELECTED_DEFAULT_TOPPING, payload)
    commit(types.UPDATE_QUANTITY_RIGHT_DEFAULT_TOPPINGS, {uuid: payload.uuid, action: constant.TOPPING.DEFAULT.REMOVE})
  },
  [types.RE_ADD_RIGHT_SELECTED_DEFAULT_TOPPING]({commit, state}, payload) {
    commit(types.RE_ADD_RIGHT_SELECTED_DEFAULT_TOPPING, payload)
    commit(types.UPDATE_QUANTITY_RIGHT_DEFAULT_TOPPINGS, {uuid: payload.uuid, action: constant.TOPPING.DEFAULT.READD})
  },
  [types.RESET_RIGHT_REMOVED_DEFAULT_TOPPINGS]({commit, state}, payload) {
    commit(types.RESET_RIGHT_REMOVED_DEFAULT_TOPPINGS, payload)
  },
  [types.RESET_RIGHT_TOPPINGS]({commit, state}, payload) {
    commit(types.RESET_RIGHT_TOPPINGS, payload)
  },
  [types.SET_SHOW_MODAL_TAKE_AWAY_LESS]({commit, state}, payload) {
    commit(types.SET_SHOW_MODAL_TAKE_AWAY_LESS, payload)
  },
  [types.SET_HUT_REWARD] ({commit, state}, payload) {
    let userRanking = {
      ...payload
    }
    if (userRanking.point && userRanking.point < 0) {
      userRanking = {
        ...userRanking,
        point: 0
      }
    }
    commit(types.SET_HUT_REWARD, userRanking)
  },
  [types.SET_MAINTAINANCE_HUT_REWARD] ({commit}, payload) {
    commit(types.SET_MAINTAINANCE_HUT_REWARD, payload)
  },
  [types.SET_SLICES_REWARD] ({commit}, payload) {
    commit(types.SET_SLICES_REWARD, payload)
  },
  [types.CHECK_IS_LAND_ON_HOMEPAGE] ({commit}, payload) {
    commit(types.CHECK_IS_LAND_ON_HOMEPAGE, payload)
  },
}



// WEBPACK FOOTER //
// ./src/store/actions.js